import { useMemo } from "react";
import { CartItem } from "@/store/CartStore";
import { RebateConfig } from "@/providers/LocationConfigurationProvider";

type Menu = {
  categories: { products: { id: string; categoryId: string }[] }[];
};

export function useRebate(
  cart: CartItem[],
  menus: Menu[] | undefined,
  rebate: RebateConfig | undefined,
  basePrice: number
) {
  const allProducts = useMemo(
    () => menus?.flatMap((m) => m.categories).flatMap((c) => c.products) ?? [],
    [menus]
  );

  const qualifyingCount = useMemo(() => {
    if (!rebate) return 0;
    return cart.reduce((total, item) => {
      const product = allProducts.find((p) => p.id === item.productId);
      return product?.categoryId === rebate.categoryId
        ? total + item.count * item.quantity
        : total;
    }, 0);
  }, [cart, allProducts, rebate]);

  const setsCount = rebate ? Math.floor(qualifyingCount / rebate.setSize) : 0;
  const discountAmount = setsCount * (rebate?.discountPerSet ?? 0);
  const finalPrice = parseFloat((basePrice - discountAmount).toFixed(2));
  const isEligible = discountAmount > 0;

  return { isEligible, discountAmount, finalPrice, setsCount, qualifyingCount };
}
